module.exports = __webpack_public_path__ + "media/images/cardboard-img-08-467cb1d1b8f73bdc4268d7dda5fe04b0.jpg";